import React, { useEffect } from "react";
import TermsAndConditions from "../../LegalDocumentPages/TermsAndConditions";

interface IProps {
    closeDialog: any;
    dialogId: string;
    packageIndex: number;
}

const IDFProtectionPlanTermsAndCondition: React.FunctionComponent<IProps> = (props) => {
    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");
    });

    return (
        <React.Fragment>
            <div className="dialog-header">&nbsp;</div>

            <div className="dialog-body large-dialog-scroll">
                <TermsAndConditions showTemrsOfUseHeader={false}> </TermsAndConditions>
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-primary"
                            id="btn-cancel-protection-plan-tnc"
                            onClick={() => {
                                window.addToDataLayer({ event: "Protection Plan - Close TNC" });
                                props.closeDialog();
                            }}
                        >
                            <span className="btn-text">Return to Cart Summary</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default IDFProtectionPlanTermsAndCondition;
